import { Alert } from '@mui/material';
import { FunctionComponent } from 'react';

type Props = {
    error: string | undefined;
};

export const InlineErrorAlert: FunctionComponent<Props> = (props) => {
	return props.error &&
        <Alert severity="error" sx={{ marginBottom: 2 }}>
        	{props.error}
        </Alert>;
};